import Barba from 'barba.js'
import SmoothScroll from 'smooth-scroll'
import 'gsap'
import 'parallax_background'

window.jQuery = window.$ = require('jquery')
const imagesLoaded = require('imagesloaded')
imagesLoaded.makeJQueryPlugin($)

/* eslint-disable no-unused-vars */
Barba.Pjax.Dom.wrapperId = 'js-pjax-wrapper'
Barba.Pjax.Dom.containerClass = 'js-pjax-container'

Barba.Pjax.start()
Barba.Prefetch.init()

const body = $('body')
const container = $('#js-container')
const transitionLoader = $('#js-transition-loader')

const DefaultTransition = Barba.BaseTransition.extend({
  start: function() {
    Promise.all([this.newContainerLoading, this.PageLeave()]).then(this.PageEnter.bind(this))
  },

  PageLeave: function() {
    return $(this.oldContainer)
      .delay(1000)
      .animate({ opacity: 0 })
      .promise()
  },

  PageEnter: function() {
    const _this = this
    const $el = $(this.newContainer)

    $(this.oldContainer).hide()

    $('html, body').scrollTop(0)

    $el.css({
      visibility: 'visible',
      opacity: 0
    })

    $el.animate({ opacity: 1 }, 0, function() {
      _this.done()
    })
  }
})

Barba.Pjax.getTransition = function() {
  return DefaultTransition
}

Barba.Dispatcher.on('linkClicked', function(HTMLElement, MouseEvent) {
  body.removeClass('is-loaded').addClass('is-loading')
  transitionLoader.removeAttr('aria-hidden').fadeIn(500)
  container.attr('aria-hidden', 'true')

  setTimeout(function() {
    container.css('visibility', 'hidden')
  }, 1000)
})

Barba.Dispatcher.on('newPageReady', function(currentStatus, oldStatus, container, newPageRawHTML) {
  if (Barba.HistoryManager.history.length === 1) {
    return
  }

  if (typeof twttr === 'undefined') {
    const twitterjs = document.createElement('script')
    twitterjs.async = true
    twitterjs.src = '//platform.twitter.com/widgets.js'
    document.getElementsByTagName('body')[0].appendChild(twitterjs)
  } else {
    twttr.widgets.load()
  }

  ga('send', 'pageview', window.location.pathname.replace(/^\/?/, '/') + window.location.search)

  return false
})

Barba.Dispatcher.on('transitionCompleted', function(HTMLElement, MouseEvent) {
  $('#js-pjax-wrapper').imagesLoaded(() => {
    body.removeClass('is-loading').addClass('is-loaded')
    transitionLoader.attr('aria-hidden', 'true').fadeOut(400)
    container.css('visibility', 'visible').removeAttr('aria-hidden')

    $('[data-parallax]').parallaxBackground()
  })

  $('.is-state-animation').css('visibility', 'hidden')

  if ($('.is-state-animation').hasClass('is-animated')) {
    $('.is-state-animation').removeClass('is-animated')
  }

  $(function() {
    const ua = navigator.userAgent
    if (ua.indexOf('iPhone') > 0 || (ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0)) {
      $('a[href^="tel:"]').css('pointer-events', 'auto')
    } else if (ua.indexOf('iPad') > 0 || ua.indexOf('Android') > 0) {
      $('a[href^="tel:"]').css('pointer-events', 'none')
    } else {
      $('a:not(.is-not-hover),.c-btn:not(.is-disabled)').addClass('is-state-hover')
      $('.c-btn a').removeClass('is-state-hover')
      $('a[href^="tel:"]').css('pointer-events', 'none')
      if ($('.is-state-hover').length) {
        $('.is-state-hover').hover(
          function() {
            $(this).addClass('is-hover')
          },
          function() {
            $(this).removeClass('is-hover')
          }
        )
      }
    }
  })

  $(function() {
    const gHeader = $('#js-global-header').height()
    const ww = $(window).width()

    function pagelink(heightnum) {
      const headerH = heightnum
      $('a[href^="#"]').click(function() {
        const href = $(this).attr('href')
        const target = $(href == '#' || href == '' ? 'body' : href)
        const notPcPosition = target.offset().top - headerH
        const pcPosition = target.offset().top

        if (ww <= 1200) {
          $('html, body').animate({ scrollTop: notPcPosition }, 800, 'swing')
        } else {
          $('html, body').animate({ scrollTop: pcPosition }, 800, 'swing')
        }
        return false
      })
    }
    pagelink(gHeader)
  })

  $('html, body').scrollTop(1)

  const loadscroll = new SmoothScroll()
  const hrefHash = location.hash
  const offset = $('#js-global-header').height()
  if (hrefHash !== '' && hrefHash !== '#pgTop' && document.getElementById(hrefHash.replace('#', '')) != null) {
    const anchor = document.querySelector(hrefHash)
    const pcOptions = { speed: 800, speedAsDuration: true, offset: 0 }
    const notPcOptions = { speed: 800, speedAsDuration: true, offset: offset }
    const ww = $(window).width()
    if (ww <= 1200) {
      setTimeout(loadscroll.animateScroll(anchor, 0, notPcOptions), 1000)
    } else {
      setTimeout(loadscroll.animateScroll(anchor, 0, pcOptions), 1000)
    }
  }
})

/* eslint-enable no-unused-vars */
